<template>
  <v-dialog v-model="visible" max-width="960px" scrollable>
    <v-card>
      <v-toolbar dense flat color="primary" dark>
        <v-toolbar-title class="text-subtitle-1 font-weight-bold">
          <v-icon left small>mdi-format-list-bulleted-type</v-icon>
          Tipos Lista Precio
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon small dark @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-4">
        <v-sheet v-if="universidad" rounded outlined class="pa-3 mb-4">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-school</v-icon>
            <div>
              <div class="text-caption grey--text">Universidad</div>
              <div class="text-subtitle-2 font-weight-medium">{{ universidad.nombre }}</div>
            </div>
          </div>
        </v-sheet>

        <div class="d-flex align-center mb-3">
          <v-btn small color="primary" @click="$refs.formularioRef.abrir()">
            <v-icon left small>mdi-plus</v-icon>
            Registrar
          </v-btn>

          <v-btn small class="ml-2" :disabled="!itemSeleccionado" @click="$refs.formularioRef.abrir(itemSeleccionado)">
            <v-icon left small>mdi-pencil</v-icon>
            Editar
          </v-btn>

          <v-btn small class="ml-2" :disabled="!itemSeleccionado" @click="confirmarEliminar">
            <v-icon left small>mdi-delete</v-icon>
            Eliminar
          </v-btn>

          <v-spacer />

          <v-btn small outlined color="primary" @click="listar" :loading="cargando">
            <v-icon left small>mdi-refresh</v-icon>
            Recargar
          </v-btn>
        </div>

        <ListadoTipoListaPrecio
          :items="items"
          :cargando="cargando"
          :item-seleccionado="itemSeleccionado"
          @seleccionar="itemSeleccionado = $event" />
      </v-card-text>

      <v-divider />

      <v-card-actions class="px-4 py-3">
        <v-spacer />
        <v-btn text color="grey darken-1" @click="cerrar">Cerrar</v-btn>
      </v-card-actions>
    </v-card>

    <FormularioTipoListaPrecio
      ref="formularioRef"
      :universidadId="universidad ? universidad.id : null"
      @guardado="listar" />

    <!-- Diálogo de confirmación de eliminación -->
    <v-dialog v-model="dialogoEliminar" max-width="400px" persistent>
      <v-card>
        <v-toolbar dense flat color="red darken-1" dark>
          <v-toolbar-title class="text-subtitle-1 font-weight-bold">
            <v-icon left small>mdi-alert</v-icon>
            Confirmar eliminación
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pa-4">
          <p class="mb-0">
            ¿Está seguro de eliminar el tipo de lista de precio
            <strong>{{ itemSeleccionado ? itemSeleccionado.nombre : '' }}</strong>?
          </p>
        </v-card-text>

        <v-divider />

        <v-card-actions class="px-4 py-3">
          <v-spacer />
          <v-btn text color="grey darken-1" @click="dialogoEliminar = false" :disabled="eliminando">
            Cancelar
          </v-btn>
          <v-btn color="red darken-1" dark :loading="eliminando" @click="eliminar">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import TipoListaPrecioService from '../../services/tipo-lista-precio.service';
import ListadoTipoListaPrecio from './ListadoTipoListaPrecio.vue';
import FormularioTipoListaPrecio from './FormularioTipoListaPrecio.vue';

export default {
  name: 'ModalTipoListaPrecio',
  components: {
    ListadoTipoListaPrecio,
    FormularioTipoListaPrecio,
  },
  props: {
    universidad: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      visible: false,
      items: [],
      cargando: false,
      itemSeleccionado: null,
      dialogoEliminar: false,
      eliminando: false,
    };
  },
  methods: {
    abrir() {
      this.visible = true;
      this.itemSeleccionado = null;
      this.listar();
    },
    cerrar() {
      this.visible = false;
      this.items = [];
      this.itemSeleccionado = null;
    },
    async listar() {
      this.cargando = true;
      this.itemSeleccionado = null;

      try {
        const params = {};

        if (this.universidad?.id) {
          params.universidadId = this.universidad.id;
        }

        const { data } = await TipoListaPrecioService.findAll({ params });

        this.items = data.datos || [];
      } catch (error) {
        const mensaje = error?.response?.data?.mensaje || error.message;

        this.items = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al obtener tipos de lista de precio',
          type: 'error',
        });
      } finally {
        this.cargando = false;
      }
    },
    confirmarEliminar() {
      if (!this.itemSeleccionado) return;
      this.dialogoEliminar = true;
    },
    async eliminar() {
      this.eliminando = true;

      try {
        await TipoListaPrecioService.remove(this.itemSeleccionado.id);

        this.$notify({
          group: 'notifications',
          title: 'Tipo Lista Precio',
          text: 'Eliminado correctamente',
          type: 'success',
        });

        this.dialogoEliminar = false;
        this.listar();
      } catch (error) {
        const mensaje = error?.response?.data?.mensaje || error.message;

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al eliminar',
          type: 'error',
        });
      } finally {
        this.eliminando = false;
      }
    },
  },
};
</script>
